function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -274,
  y: -193,
  width: 714,
  height: 584,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6476 3.23808C17.0684 3.59577 17.1196 4.22686 16.7619 4.64767L8.26194 14.6476C8.07356 14.8693 7.79803 14.9979 7.50717 15C7.21631 15.0021 6.93896 14.8774 6.74743 14.6585L3.24744 10.6585C2.88376 10.2429 2.92587 9.61111 3.34151 9.24743C3.75714 8.88375 4.38891 8.92587 4.75259 9.3415L7.48903 12.4689L15.238 3.35237C15.5957 2.93156 16.2268 2.88039 16.6476 3.23808Z",
  fill: "#f7b500"
});

var SvgTxSuccess = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTxSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tx-success.f2e471f7.svg";
export { ForwardRef as ReactComponent };